var scope_0 = require('/Users/jasonchappell/pm-skillz-starter/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a780d50986621be3ad661d0e45b4dc2a.js').default;
var scope_1 = require('/Users/jasonchappell/pm-skillz-starter/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    